import React from 'react';

import { Dashboard } from 'presentation/pages';

export const MakeDashboardFactory: React.FC = () => {
  return <Dashboard />;
};
